module.exports = __webpack_public_path__ + "3cb045928970027902649980f00a4eee.MP3";